import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d0e3790"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "readable"
}
const _hoisted_2 = {
  key: 2,
  class: "user-role-digest"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "buttons-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_StripInput = _resolveComponent("StripInput")!
  const _component_MultiCheckBox = _resolveComponent("MultiCheckBox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: !!_ctx.filterEditing,
    title: "Save filter",
    close: _ctx.handleClose,
    class: "filter-form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        _createVNode(_component_TextInput, {
          value: _ctx.name,
          label: "filter name",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.name = $event))
        }, null, 8, ["value"]),
        (_ctx.filterEditMode === 'edit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.readable), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_SelectInput, {
          value: _ctx.frequency,
          label: "email digest",
          options: ['', 'daily', 'monthly', 'weekly'],
          "option-labels": ['never', 'daily', 'monthly', 'weekly'],
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.frequency = $event))
        }, null, 8, ["value"]),
        (_ctx.frequency === 'weekly')
          ? (_openBlock(), _createBlock(_component_StripInput, {
              key: 1,
              value: _ctx.day,
              label: "every",
              options: _ctx.stripDayOptions,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.day = $event))
            }, null, 8, ["value", "options"]))
          : _createCommentVNode("", true),
        (_ctx.frequency !== '' && _ctx.userRoles.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_MultiCheckBox, {
                title: "Which user roles should receive this digest",
                header: "User Roles",
                selected: _ctx.selectedUserRoles,
                options: _ctx.multiMetricUserRoles,
                "disable-highlighting-count": "",
                "wider-selection-box": "",
                onToggle: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSelectedUserRoles($event)))
              }, null, 8, ["selected", "options"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.filterEditMode === 'edit')
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 0,
                secondary: "",
                caution: "",
                click: _ctx.handleDelete
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Delete ")
                ], undefined, true),
                _: 1
              }, 8, ["click"]))
            : _createCommentVNode("", true),
          _createVNode(_component_BaseButton, {
            primary: "",
            muted: "",
            click: _ctx.handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ], undefined, true),
            _: 1
          }, 8, ["click"]),
          _createVNode(_component_BaseButton, {
            primary: "",
            click: _ctx.handleSave
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Save ")
            ], undefined, true),
            _: 1
          }, 8, ["click"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["show", "close"]))
}